import React, {useState} from "react";
import {
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap";
import {connect} from "react-redux";
import { history } from "@src/history"
import { logout }  from '@store/actions/auth/loginActions';
import { OreId} from "oreid-js";
import { WebPopup } from "oreid-webpopup";
import { withUAL } from 'ual-reactjs-renderer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons'


const oreIdOptions = {
  appName: "ORE ID Login",
  appId: process.env.REACT_APP_OREID_APP_ID,
  plugins: { popup: WebPopup() }
}
var oreId = new OreId(oreIdOptions);
oreId.init()
const handleNavigation = (e, path) => {
  e.preventDefault();
  history.push(path)
}
const UserDropdown = props => {
  const [showDropdown,setShowDropdown] = useState(false)
  const [showProfileDropdown,setShowProfileDropdown] = useState(false)
  const [showInventoryDropdown,setShowInventoryDropdown] = useState(false)
  const [showIMarketDropdown,setShowMarketDropdown] = useState(false)
  const [showPlay,setShowPlay] = useState(false)
  const toggleDropdown = () => setShowDropdown((prevState) => !prevState);
  const toggleProfileDropdown = () => setShowProfileDropdown((prevState) => !prevState);
  const toggleInventoryDropdown = () => setShowInventoryDropdown((prevState) => !prevState);
  const toggleMarketDropdown = () => setShowMarketDropdown((prevState) => !prevState);
  const togglePlay = () => setShowPlay((prevState) => !prevState);
  return (
    <DropdownMenu right>
      <DropdownToggle className="close_button" >
    <svg><use href="/img/icon_menu_right.svg#close_x"/></svg>
    </DropdownToggle>
      <DropdownItem divider style={{marginTop:'62px'}}/>
      <div className="socket_info" >
        <DropdownItem  style={{paddingLeft:'25px',paddingTop:'16px',paddingBottom:'9px'}}
          tag="span"
          onClick={()=>{}}
        >
            Socket status: {props.socket_connected ? <span className="green" style={{marginLeft:'52.5px'}}>connected</span>:<span className="red" style={{marginLeft:'37.5px'}}>disconnected</span>}
        </DropdownItem>
        <DropdownItem style={{paddingLeft:'25px',paddingTop:'0',paddingBottom:'9px'}}
          tag="span"
          onClick={()=>{}}
        >
            Socket login: {props.socket_user ? <span className="green" style={{paddingRight:'8.4px',paddingLeft:'10px',marginLeft:'60.5px'}}>logged in</span>:<span className="red" style={{paddingRight:'5px',paddingLeft:'7px',marginLeft:'46px'}}>not logged in</span>}
        </DropdownItem>
        <DropdownItem style={{paddingLeft:'25px',paddingTop:'0',paddingBottom:'16px'}}
          tag="span"
          onClick={()=>{}}
        >
            Atomicassets: {props.got_nft_list ? <span className="green">connected</span>:<span className="red" style={{marginLeft:'40px'}}>disconnected</span>}
        </DropdownItem>
      </div>
      
        <DropdownItem divider />
        <div className="overflow_container">
        <a className="dropdown-item" onClick={toggleInventoryDropdown}>
          <svg><use href="/img/icon_menu_right.svg#my_cards"/></svg>
          <span className="align-middle">My Inventory</span>  
          <FontAwesomeIcon icon={!showInventoryDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/> 
        </a>
        {showInventoryDropdown && <>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/cards")}>
              <svg><use href="/img/icon_menu_right.svg#my_cards"/></svg>
              <span className="align-middle">My Cards</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/wallet")}>
              <svg><use href="/img/icon_menu_right.svg#wallet"/></svg>
              <span className="align-middle">Wallet</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/arcadex")}>
              <svg><use href="/img/icon_menu_right.svg#wallet"/></svg>
              <span className="align-middle">My Arcadex</span>
            </a>
            
            <DropdownItem divider />
          </>
        }
        <DropdownItem divider />
         <a className="dropdown-item" onClick={togglePlay}>
          <svg><use href="/img/icon_menu_right.svg#mini_games"/></svg>
          <span className="align-middle">Play</span>  
          <FontAwesomeIcon icon={!showPlay ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/> 
        </a>
        {showPlay && <>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/mining")}>
              <svg><use href="/img/icon_menu_right.svg#mining"/></svg>
              <span className="align-middle">Arcadian Mining</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/mining_grid")}>
              <svg><use href="/img/icon_menu_right.svg#mini_games"/></svg>
              <span className="align-middle">Apertian Region</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/shadow_depths")}>
              <svg><use href="/img/icon_menu_right.svg#mini_games"/></svg>
              <span className="align-middle">Shadow Depths</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/spin")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle"> Spin and win</span>
            </a>
            <DropdownItem divider />
            
            <DropdownItem divider />
          </>
        }
        <DropdownItem divider />
        <a className="dropdown-item" onClick={toggleProfileDropdown}>
          <svg><use href="/img/icon_menu_right.svg#profile"/></svg>
          <span className="align-middle">Profile</span>  
          <FontAwesomeIcon icon={!showProfileDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/> 
        </a>
        {showProfileDropdown && <>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/profile")}>
              <svg><use href="/img/icon_menu_right.svg#profile"/></svg>
              <span className="align-middle">Profile</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/ranks")}>
              <svg><use href="/img/icon_menu_right.svg#profile"/></svg>
              <span className="align-middle">Ranks</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/achievements")}>
              <svg><use href="/img/icon_menu_right.svg#profile"/></svg>
              <span className="align-middle">Achievements</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/rank_rolls")}>
              <svg><use href="/img/icon_menu_right.svg#profile"/></svg>
              <span className="align-middle">Rank Rolls</span>
            </a>
            
            <DropdownItem divider />
          </>
        }
        {false && <DropdownItem divider />}
        {false && <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/pvp")}
        >
            <svg><use href="/img/icon_menu_right.svg#mini_games"/></svg>
            <span className="align-middle">PVP</span>
        </DropdownItem>}
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/arcadia")}
        >
            <svg><use href="/img/icon_menu_right.svg#wallet"/></svg>
            <span className="align-middle">Arcadia</span>
        </DropdownItem>
        <DropdownItem divider />
        
        <a className="dropdown-item" onClick={toggleMarketDropdown}>
          <svg><use href="/img/icon_menu_right.svg#market"/></svg>
          <span className="align-middle">Market</span>  
          <FontAwesomeIcon icon={!showIMarketDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/> 
        </a>
        <DropdownItem divider />
        {showIMarketDropdown && <>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/market")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle"> Marketplace</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/shop")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle"> NBM Shop</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/market_sales")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">History</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/market_sales_weekly")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">Weekly Leaderboard</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "market_sales_monthly")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">Monthly Leaderboard</span>
            </a>
            {/* <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "alchemist")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">Alchemist</span>
            </a> */}
          </>
        }
        
        <a className="dropdown-item" onClick={toggleDropdown}>
          <svg><use href="/img/icon_menu_right.svg#market"/></svg>
          <span className="align-middle">NBM Academy</span>  
          <FontAwesomeIcon icon={!showDropdown ? faAngleDown : faAngleUp} className="icon_arrow_mobile"/> 
        </a>
        {showDropdown && <>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/tutorials")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">Tutorials</span>
            </a>
            <a className="dropdown-item double-dropdown" 
               target="_blank"
               href = "https://nbmofficialwiki.gitbook.io/nbm-shadow-depths/"
               onClick={toggleDropdown}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">NBM Wiki</span>
            </a>
            
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/library")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">NBM Library</span>
            </a>
            <a className="dropdown-item double-dropdown" onClick={e => handleNavigation(e, "/mining_calc")}>
              <svg><use href="/img/icon_menu_right.svg#market"/></svg>
              <span className="align-middle">Calculator</span>
            </a>
            <DropdownItem divider />
          </>
        }
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/shop")}
        >
            <svg><use href="/img/icon_menu_right.svg#shop"/></svg>
            <span className="align-middle">NBM Shop</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/packs")}
        >
            <svg><use href="/img/icon_menu_right.svg#packs"/></svg>
            <span className="align-middle">Pack Opening</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/blending")}
        >
            <svg><use href="/img/icon_menu_right.svg#blending"/></svg>
            <span className="align-middle">Blending</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/votings")}
        >
            <svg><use href="/img/icon_menu_right.svg#lucky_draw"/></svg>
            <span className="align-middle">Voting</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/sales")}
        >
            <svg><use href="/img/icon_menu_right.svg#sales"/></svg>
            <span className="align-middle">Sales</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
        tag="a"
        href="#"
        onClick={e => handleNavigation(e, "/leaderboard")}>
            <svg><use href="/img/icon_menu_right.svg#leaderboard"/></svg>
            <span className="align-middle">Leaderboards</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/lucky_draw")}
        >
            <svg><use href="/img/icon_menu_right.svg#lucky_draw"/></svg>
            <span className="align-middle">Lucky Draw</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/auctions")}
        >
            <svg><use href="/img/icon_menu_right.svg#auctions"/></svg>
            <span className="align-middle">Auctions</span>
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem
          tag="a"
          href="https://nftbattleminers.com/"
          target="_blank"
        >
            <svg><use href="/img/icon_menu_right.svg#website"/></svg>
            <span className="align-middle">Website</span>
        </DropdownItem>
        <DropdownItem divider />
        {props.socket_user?.role === 'admin' && <DropdownItem
          tag="a"
          href="#"
          onClick={e => handleNavigation(e, "/admin")}
        >
            <svg><use href="/img/icon_menu_right.svg#my_cards"/></svg>
            <span className="align-middle">Admin</span>
        </DropdownItem>}
        <DropdownItem divider />
      <DropdownItem
        tag="a"
        href="#"
        onClick={async e =>  {
            e.preventDefault();
            localStorage.removeItem('wax-login');
            localStorage.removeItem('ssn');
            localStorage.removeItem('ore-login');
            if(props.ual){
                props.ual.logout();
                oreId.logout()
            }
            window.location.href = window.location.href;
        }}
      >
        <svg><use href="/img/icon_menu_right.svg#log_out"/></svg>
        <span className="align-middle">Log Out</span>
      </DropdownItem>
      </div>
    </DropdownMenu>
    
  )
  
}
const mapStateToProps = state => {
  return {
    user: state.authorizedUser.user,
    wax: state.authorizedUser.wax,
    socket_user: state.socket.socket_user,
    socket_connected: state.socket.socket_connected,
    got_nft_list:state.nft.got_nft_list
  }
}

export default withUAL(connect(mapStateToProps, {logout})(UserDropdown))